module.exports = __webpack_public_path__ + "img/dispatch.2aec45fc.svg";